/**
 * Property service – fetches pre-approved project data from the Liferay headless API.
 */

import { oauth2Instance } from './liferay';

const OBJECT_API_URL = '/o/c/preapprovedproperties/';

/**
 * Map a single API item to the shape expected by PropertyCard.
 */
function mapItem(item) {
  let imageUrl = '';
  if (item.propertyImage?.link?.href) {
    const baseUrl = oauth2Instance.getPortalURL();
    const href = item.propertyImage.link.href;
    imageUrl = href.startsWith('http') ? href : `${baseUrl}${href}`;
  }

  return {
    id: item.id,
    name: item.projectName || '',
    developer: item.builderName || '',
    location: item.locality || '',
    city: item.location?.name || '',
    bhk: item.configuration || '',
    propertyType: item.propertyType || '',
    status: item.possessionStatus?.name || '',
    price: item.budgetRage || '',
    image: imageUrl,
    reraRegistered: item.rERARegistered === true,
  };
}

/**
 * Fetch all pre-approved properties.
 * @param {number} [page=1]
 * @param {number} [pageSize=100]
 * @returns {Promise<{ items: Array, totalCount: number }>}
 */
export async function fetchProperties(page = 1, pageSize = 500) {
  const headers = await oauth2Instance.getHeaders();
  const baseUrl = oauth2Instance.getPortalURL();
  const url = `${baseUrl}${OBJECT_API_URL}?page=${page}&pageSize=${pageSize}`;

  const response = await fetch(url, { method: 'GET', headers });

  if (!response.ok) {
    throw new Error(`Failed to fetch properties: ${response.status}`);
  }

  const data = await response.json();
  const rawItems = data?.items ?? [];
  const items = rawItems.map(mapItem);

  return {
    items,
    totalCount: data?.totalCount ?? items.length,
    page: data?.page ?? page,
    lastPage: data?.lastPage ?? 1,
  };
}
